import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { Observable, throwError } from 'rxjs';
import firebase, { auth } from 'firebase/app';
import { ApiService } from './api.service';
import { UserProfile } from '../_models/models';
import { StorageService } from '.';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FirebaseLoginService {
  userData: Observable<firebase.User>;
  userUID: string;
  userProfile: UserProfile = {uid: null, email: null};
  userPermission = {canEditEntities: false, canEditEvents: false};

  isRegisteredByOperator = false;

  constructor(
      public afAuth: AngularFireAuth,
      private _api: ApiService,
      private _storage: StorageService
  ) {
      this.userData = afAuth.authState;
    }

  /*Login with google */
  googleAuth() {
    return this.authLogin(new auth.GoogleAuthProvider());
  }

  getCurrentUser() {
    return this.userData;
  }

  // google login
  authLogin(provider: auth.AuthProvider) {
    return this.afAuth.signInWithPopup(provider)
    .then((result) => {
      this.afAuth.currentUser
      .then(currentUser => {
        currentUser.getIdToken()
        .then(idToken => {
          const user = result.user;
          const userName = result.user.displayName;
          const token = idToken;
          this.userUID = user.uid;
          this._storage.saveJWTaccessToken(token);
          this._storage.saveUser(userName);
        });
      });
    }).catch((error) => {
        throw(error);
    });
  }

  // sign in
  signIn(email: string, password: string) {
    return this.afAuth.signInWithEmailAndPassword(email, password)
    .then(result => {
      this.afAuth.currentUser
      .then(currentUser => {
        currentUser.getIdToken()
        .then(idToken => {
          const user = result.user;
          const userName = user.email;
          const token = idToken;
          this.userUID = user.uid;
          this.userProfile = user;
          this._storage.saveJWTaccessToken(token);
          this._storage.saveUser(userName);
        }).catch(err => {
          throw(err);
        });
      }).catch(err =>  {
        throw(err);
      });
    }).catch((err) => {
        throw(err);
    });
  }

  // register user into Firebase
  async doRegisterFirebase(email: string, profile: UserProfile) {
    try {
      // TODO: verificare che vada bene la generazione psw
      // const randomstring = Math.random().toString(36).substr(2, 8);
      profile.psw = profile.email;
      /*this.afAuth.currentUser.then(originalUser => {
        this.afAuth.createUserWithEmailAndPassword(email, profile.psw).then(result=>{
          this.afAuth.currentUser.then(currentUser => {
            currentUser.getIdToken().then( idToken => {
              this.afAuth.updateCurrentUser(originalUser).then(jjjj=>{
                const user = result.user;
                const userUID = user.uid;
                this.doRegisterUserProfile(userUID, profile);
                this.forgotPassword(email);
              });
            });
          });
        });
      });*/

      const originalUser = await this.afAuth.currentUser;
      const result = await this.afAuth.createUserWithEmailAndPassword(email, profile.psw);


      const user = result.user;
      const userUID = user.uid;
      await this.forgotPassword(email);
      await this.sendVerificationMail(user);

      await this.afAuth.updateCurrentUser(originalUser);

      this.doRegisterUserProfile(userUID, profile);
    } catch (error) {
        throw(error.message);
    }
  }

  // check if user is registered
  doCheckRegisteredUser() {
    return this._api.getUserProfile(this.userUID).pipe(catchError(error => {
      return throwError(error);
    })).subscribe();
  }

  // do register user profile
  doRegisterUserProfile(uid: string, profile: UserProfile) {
    return this._api.postRegisterUserProfile(this.isRegisteredByOperator = true, uid, profile).pipe(catchError(error => {
      return throwError(error);
    })).subscribe();
  }

  // Send email verification when new user sign up
  async sendVerificationMail(user: firebase.User) {
    return user.sendEmailVerification();
  }

  // Reset forgot password
  async forgotPassword(passwordResetEmail: string) {
    await this.afAuth.sendPasswordResetEmail(passwordResetEmail);
    return true;
  }

  isLoggedInFire(): boolean {
    const user = this._storage.getUser() || this._storage.getJWTaccesToken();
    return user !== null;
  }

  // Sign out
  signOut() {
    this.afAuth.signOut();
    this._storage.clearJWTaccessToken();
    this._storage.clearUser();
    this._storage.clearUserPermission();
  }

  getToken() {
    this.afAuth.idToken.subscribe(idToken => {
      console.log(idToken);
    });
  }

}
